var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChemistrycard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105.82mm",
    height: "122mm",
    viewBox: "0 0 105.82 122",
    xmlSpace: "preserve",
    id: "svg100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs104"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7144"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffadad",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop7142"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7130"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffadad",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop7128"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.986 -104.45)",
    id: "g98"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 45.305 104.45)",
    id: "g96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m170.09 411.83c0.333 0 0.671-0.034 1.01-0.103 35.866-7.359 61.897-39.286 61.897-75.917 0-2.761-2.238-5-5-5s-5 2.239-5 5c0 31.904-22.671 59.712-53.907 66.121-2.705 0.555-4.448 3.198-3.894 5.903 0.487 2.366 2.569 3.996 4.894 3.996z",
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.41 266.9c-1.951-1.952-5.119-1.952-7.07 0-1.953 1.953-1.953 5.119 0 7.071 16.545 16.545 25.657 38.506 25.657 61.837 0 48.245-39.25 87.495-87.494 87.495-24.07 0-47.344-10.111-63.853-27.74-1.888-2.016-5.051-2.121-7.067-0.232-2.016 1.887-2.119 5.051-0.231 7.067 18.393 19.641 44.326 30.905 71.151 30.905 53.759 0 97.494-43.736 97.494-97.495-1e-3 -26.002-10.153-50.474-28.587-68.908z",
    fill: "#0ff",
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.25 229.81v-46.531c8.62-0.387 15.519-7.5 15.519-16.214 0-8.961-7.29-16.251-16.251-16.251h-100.04c-8.961 0-16.251 7.29-16.251 16.251 0 8.714 6.899 15.827 15.519 16.214v46.532c-40.653 19.491-66.742 60.737-66.742 105.99 0 64.787 52.708 117.5 117.49 117.5 64.786 0 117.49-52.708 117.49-117.5 0-45.254-26.093-86.502-66.747-105.99zm-107.02-62.744c0-3.447 2.804-6.251 6.251-6.251h100.04c3.447 0 6.251 2.804 6.251 6.251s-2.804 6.251-6.251 6.251h-100.04c-3.447 0-6.251-2.804-6.251-6.251zm56.27 276.23c-59.272 0-107.49-48.222-107.49-107.5 0-42.402 25.035-80.959 63.78-98.229 1.876-0.836 3.02-2.713 2.962-4.708v-49.549h81.5v49.689c0 1.974 1.161 3.763 2.965 4.567 38.745 17.27 63.781 55.827 63.781 98.229 0 59.275-48.221 107.5-107.49 107.5z",
    fill: "#ff7f2a",
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.94 48.211h5.804v95.4c0 2.761 2.238 5 5 5s5-2.239 5-5v-95.4h103v20c0 2.761 2.238 5 5 5s5-2.239 5-5v-20h5.804c8.961 0 16.251-7.29 16.251-16.251s-7.291-16.251-16.252-16.251h-134.61c-8.961 0-16.251 7.29-16.251 16.251s7.29 16.251 16.251 16.251zm0-22.502h134.61c3.447 0 6.251 2.804 6.251 6.251s-2.804 6.251-6.251 6.251h-134.61c-3.447 0-6.251-2.804-6.251-6.251s2.803-6.251 6.251-6.251z",
    fill: "#800080",
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m415.1 379.22-72.829-186.16v-85.435h2.635c8.961 0 16.251-7.29 16.251-16.251 0-8.961-7.29-16.251-16.251-16.251h-83.642c-8.961 0-16.251 7.29-16.251 16.251 0 8.961 7.29 16.251 16.251 16.251h2.635v85.429l-20.191 51.594c-1.006 2.572 0.263 5.472 2.834 6.479 2.57 1.006 5.472-0.263 6.479-2.834l19.286-49.282h61.555l71.928 183.85c3.104 7.923 2.133 16.498-2.663 23.527-4.799 7.035-12.436 11.069-20.952 11.069h-127.43c-2.762 0-5 2.239-5 5s2.238 5 5 5h127.43c11.699 0 22.62-5.77 29.213-15.434 6.59-9.658 7.978-21.924 3.714-32.808zm-160.09-287.85c0-3.447 2.804-6.251 6.251-6.251h83.642c3.447 0 6.251 2.804 6.251 6.251s-2.804 6.251-6.251 6.251h-83.642c-3.447 0-6.251-2.804-6.251-6.251zm77.258 16.251v81.386h-58.372v-81.386z",
    fill: "#008080",
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.18 249.59 54.994 140.56c0.772 1.973 2.659 3.18 4.657 3.18 0.606 0 1.223-0.111 1.82-0.345 2.572-1.006 3.841-3.906 2.835-6.478l-54.994-140.56c-1.007-2.572-3.911-3.841-6.478-2.834-2.571 1.005-3.84 3.905-2.834 6.477z",
    fill: "#c83737",
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.99 221.66c-1.008-2.572-3.907-3.839-6.479-2.834-2.571 1.006-3.84 3.907-2.834 6.479l3.925 10.03c0.772 1.973 2.659 3.179 4.657 3.179 0.606 0 1.223-0.111 1.821-0.345 2.571-1.006 3.84-3.907 2.834-6.479z",
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.73 275.23 37.943 96.979c0.772 1.973 2.659 3.18 4.657 3.18 0.606 0 1.223-0.111 1.821-0.345 2.571-1.006 3.84-3.906 2.834-6.478l-37.943-96.979c-1.007-2.572-3.907-3.841-6.479-2.834-2.571 1.005-3.839 3.906-2.833 6.477z",
    fill: "#000080",
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.25 182.71c2.762 0 5-2.239 5-5v-60c0-2.761-2.238-5-5-5s-5 2.239-5 5v60c0 2.761 2.239 5 5 5z",
    fill: "#e3dbdb",
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.25 65.211v45c0 2.761 2.238 5 5 5s5-2.239 5-5v-45c0-2.761-2.238-5-5-5s-5 2.239-5 5z",
    fill: "#f4d7d7",
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.75 227.05c2.762 0 5-2.239 5-5v-29c0-2.761-2.238-5-5-5s-5 2.239-5 5v29c0 2.761 2.239 5 5 5z",
    fill: "#000080",
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.75 227.05c2.762 0 5-2.239 5-5v-9c0-2.761-2.238-5-5-5s-5 2.239-5 5v9c0 2.761 2.239 5 5 5z",
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.75 203.55c1.31 0 2.6-0.54 3.53-1.47 0.939-0.93 1.47-2.22 1.47-3.53 0-1.32-0.53-2.61-1.47-3.54-0.931-0.93-2.21-1.46-3.53-1.46s-2.61 0.53-3.54 1.46-1.46 2.22-1.46 3.54 0.53 2.6 1.46 3.53 2.22 1.47 3.54 1.47z",
    id: "path94"
  })))), /*#__PURE__*/React.createElement("rect", {
    style: {
      mixBlendMode: "multiply",
      fill: "#ff8e8e",
      fillOpacity: 0.10212766,
      fillRule: "evenodd",
      stroke: "#840000",
      strokeWidth: 1.464,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.450777
    },
    id: "rect262",
    width: 103.02634,
    height: 118.93182,
    x: 1.3825192,
    y: 1.685971,
    ry: 7.1569595
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemistrycard);
export default __webpack_public_path__ + "static/media/chemistrycard.bfc6c48bbfee1996c447fcc588478cdb.svg";
export { ForwardRef as ReactComponent };